/**
 * 禁用词图片相关API
 */
import http from './http'

export default class StopwordImageApi {
    static isCompletePay_ad2(params) {
        return http.httpPost('stopwordImg/isCompletePayAd2', params);
    }

    static addOrderForm_ad2(params) {
        return http.httpPost('stopwordImg/addOrderFormAd2', params);
    }

    static startImage(token) {
        return http.httpPost('stopwordImg/startImage', {token});
    }

    static clearImage(token) {
        return http.httpPost('stopwordImg/clearImage', {token});
    }
}



// WEBPACK FOOTER //
// ./app/api/stopword.image.api.js